import React, { useEffect, useState } from 'react';
import { useAINews } from '../hooks/useAINews';
import { motion, AnimatePresence } from 'framer-motion';
export function AINewsNarrator() {
  const {
    news,
    loading
  } = useAINews();
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentNews = news[currentIndex];
  // Auto-rotate news items every 5 seconds
  useEffect(() => {
    if (loading || news.length === 0) return;
    const rotateInterval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % news.length);
    }, 5000);
    return () => clearInterval(rotateInterval);
  }, [news, loading]);
  if (loading || !currentNews) return null;
  return <div className="flex items-center gap-3 min-w-0" data-id="element-171">
      {/* Green pulsing dot indicator */}
      <div className="relative shrink-0" data-id="element-172">
        <div className="w-2 h-2 rounded-full bg-green-400" data-id="element-173" />
        <div className="absolute inset-0 w-2 h-2 rounded-full bg-green-400 animate-ping" data-id="element-174" />
      </div>

      {/* News content with crossfade */}
      <div className="flex-1 min-w-0 overflow-hidden" data-id="element-175">
        <AnimatePresence mode="wait" data-id="element-176">
          <motion.div key={currentIndex} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeInOut'
        }} className="flex items-center gap-2" data-id="element-177">
            {/* Small category tag */}
            {currentNews.category && <span className="px-2 py-0.5 rounded text-[10px] font-medium uppercase tracking-wide bg-white/5 text-white/60 shrink-0" data-id="element-178">
                {currentNews.category}
              </span>}

            {/* News headline */}
            <span className="text-sm text-white/90 truncate" data-id="element-179">
              {currentNews.title}
            </span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}